import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find'
import undefsafe from 'undefsafe'
import sitesConfig from '../../../config/sites/'
import categoriesConfig from '../../../config/sites/categories/'

const recommendationsLimit = sitesConfig['defaults'].recommendations_limit

const rootCategoryRecommendations = (results, rootCategoryPaths) => {
  const tagAggregations = undefsafe(results, 'aggregations.tags')
  if (isEmpty(tagAggregations)) {
    return [ ]
  } else {
    const lowercasedRootCategories = rootCategoryPaths.map((category) => {
      return category.toLowerCase()
    })

    let recommendations = []
    let index = 0
    while (recommendations.length < recommendationsLimit) {
      let tag = tagAggregations[index]
      if (!tag) {
        break
      }
      if (!lowercasedRootCategories.includes(tag.key)) {
        recommendations.push(tag.key)
      }
      index++
    }
    return recommendations
  }
}

const fetchRecommendedSearchesByCategoryResults =
  (query, results, currentSite) => {
    const siteRootCategories = categoriesConfig[currentSite]
    const siteRootCategoryPaths = siteRootCategories.reduce((paths, category) => {
      paths.push(category.path)
      return paths
    }, [])

    if (siteRootCategoryPaths.includes(query.category)) {
      const rootCategory = find(siteRootCategories, { path: query.category })
      return {
        type: 'fetchRecommendedSearchesByCategoryResultsSuccess',
        payload: {
          type: 'tags',
          recommendations: rootCategoryRecommendations(results, siteRootCategoryPaths),
          hint: rootCategory.name
        }
      }
    } else {
      return { type: 'fetchRecommendedSearchesByCategoryResultsFailure' }
    }
  }

export default fetchRecommendedSearchesByCategoryResults



// WEBPACK FOOTER //
// ./common/actions/search/fetchRecommendedSearchesByCategoryResults.js